import PropTypes from "prop-types"
import { useState, useEffect } from "react"
import { Helmet } from "react-helmet-async"
import { useLocation } from "react-router-dom"

import OrderNumber from "areas/order/order-number"
import { jewlr_t } from "helpers/application"
import { getHreflangs } from "helpers/meta"

import { FormContainer, FormWrapper, Text } from "../components"
import Heading from "../heading"
import fetchOrder from "../hoc/fetch-order"

import Complete from "./complete"
import OrderForm from "./order-form"

const UpgradeShipping = ({ data }) => {
  const [orderData, setData] = useState(null)
  const [completed, setCompleted] = useState(false)

  const location = useLocation()

  const hreflangs = getHreflangs(
    location.pathname,
    [],
    ["shipping", "delivery"]
  )

  useEffect(() => {
    setData(data)
  }, [data])

  let content = (
    <FormContainer>
      <FormWrapper>
        <Heading rmaType="upgrade-shipping" />
        <Text>
          Complete this form to upgrade your {jewlr_t("terms.shipping")} method.
          Please note, this change can only be made if your order has not yet
          shipped. If you need further assistance, contact customer service at{" "}
          <a
            className="nowrap"
            href={`tel:${sl.config.customer_service_toll_free}`}
          >
            {sl.config.customer_service_toll_free}
          </a>{" "}
          or{" "}
          <a
            className="nowrap"
            href={`mailto:${sl.config.customer_service_email}`}
          >
            {sl.config.customer_service_email}
          </a>{" "}
          .
        </Text>
      </FormWrapper>
      <OrderNumber
        rmaType="upgrade-shipping"
        setData={setData}
        validatePath="/secure/api/v10/order/order_shipping_methods"
      />
    </FormContainer>
  )

  if (orderData && orderData.order) {
    if (completed) {
      content = <Complete orderData={orderData} />
    } else {
      content = <OrderForm orderData={orderData} setCompleted={setCompleted} />
    }
  }

  return (
    <>
      <Helmet>
        {hreflangs.map(({ href, hreflang }) => (
          <link
            href={href}
            hrefLang={hreflang}
            key={hreflang}
            rel="alternate"
          />
        ))}
      </Helmet>
      {content}
    </>
  )
}

UpgradeShipping.propTypes = {
  data: PropTypes.object,
}

export default fetchOrder(UpgradeShipping)
